/**
 * The `ver` claim of an Entra ID access token ("1.0" or "2.0"), or null when the token can't be read.
 * Only used to tell the user that the app registration issues v1 tokens, which Privanot refuses.
 */
export const accessTokenVersion = (accessToken: string): string | null => {
    const payload = accessToken.split('.')[1];
    if (!payload) {
        return null;
    }
    try {
        const base64 = payload
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(Math.ceil(payload.length / 4) * 4, '=');
        const claims = JSON.parse(atob(base64)) as { ver?: unknown };
        return typeof claims.ver === 'string' ? claims.ver : null;
    } catch {
        return null;
    }
};
